import Vue from "vue";
import base from "../../baseMarketing";

export default Object.assign(
    {
      apiUrl: "/email",

      async test({ emailId, emails }) {
        const url = this.userUrl({ path: `/${emailId}/test` });

        return Vue.http.post(url, {
          key: emails
        });
      },

      async send({ emailId, schedulerDate }) {
        const url = this.userUrl({ path: `/${emailId}/send` });

        return Vue.http.post(url, {
          schedulerDate
        });
      },

      async resend({emailId}) {
        const url = this.userUrl({ path: `/${emailId}/resend` });

        return Vue.http.post(url);
      }
    },
    base
);
